import {
  ChatCircleDots,
  CreditCard,
  ShieldCheck,
  Monitor,
  UserCircle,
  Buildings,
  Lifebuoy,
  Question,
  Heart,
  Sparkle,
  type Icon,
} from "@phosphor-icons/react";

export const FAQ_ICON_KEYS = [
  "ChatCircleDots",
  "CreditCard",
  "ShieldCheck",
  "Monitor",
  "UserCircle",
  "Buildings",
  "Lifebuoy",
  "Question",
  "Heart",
  "Sparkle",
] as const;

export type FaqIconKey = (typeof FAQ_ICON_KEYS)[number];

export const FAQ_ICONS: Record<FaqIconKey, Icon> = {
  ChatCircleDots,
  CreditCard,
  ShieldCheck,
  Monitor,
  UserCircle,
  Buildings,
  Lifebuoy,
  Question,
  Heart,
  Sparkle,
};

export const DEFAULT_FAQ_ICON: FaqIconKey = "Question";
